import { Store } from "./store.js";
import { Utility } from "../utility.js";
import {Level} from "./level.js";

export class LionDance extends Store {
    static info = {
        key: "lion-dance",
        name: "Find and follow lion dance",
        description: "The Lion Dance is another fun part of the celebration to welcome good luck and prosperity in the new year. " +
            "Find the lion in the store and join the lion dance from behind. You and your friends need to be quick, the lion gets faster!",
        logo: { x: 750, y: 520 },
        won: false,
        maxTries: 3
    }
    constructor(key, level){
        super(key, level, { holder: false, fullscreen: true, bobInRed: true })
        this._lion = {
            paths: [
                ["S740", "W500", "N130", "W1100", "N750", "E250", "S180", "E250", "N500", "W800", "S650", "E580", "N100", "E300", "S500", "E460", "N1070", "E200", "S50", "W200", "S450", "E510", "N20", "E50"],
                ["W1000", "S600", "E300", "N100", "E150", "N500", "E500", "S480", "E500", "S250", "W50", "N250", "W1000", "S150", "W1000", "N450", "W300", "N650", "E300", "S300", "E280", "S170", "E1320"],
                ["S450", "E500", "S250", "W150", "N250", "W1000", "S150", "W930", "N100", "W250", "S300", "W50", "N370", "E300", "S150", "E550", "N480", "W520", "S100", "W380", "N665", "E320", "S330", "E260", "S150", "E1300", "N15", "E50" ]
            ],
            sprite: null,
            last: null,
            current: null,
            distance: () => Math.sqrt(Math.pow(this._lion.sprite.x - this._lion.last.x, 2) + Math.pow(this._lion.sprite.y - this._lion.last.y, 2)),
            speed: () => this._lion.mounted + 3,
            mounted: 0
        }
        this._bobLion = null
        this._totalStars = null

        this.lionAnim = null
        this._bobInLionsBack = false
    }
    preload(){
        super.preload()
        this.load.spritesheet("lion", "assets/lion-dance/ffl-lion-sprite.png", {
            frameWidth: 162,
            frameHeight: 213
        });
    }
    create(){
        super.create()
        this.peiPeiSay("Go catch that lion!")
        this._lion.sprite = this.physics.add.sprite(0, 0, "lion").setCollideWorldBounds(true).setScale(1).setVisible(false)
        this._lion.sprite.setOffset(this._lion.sprite.body.x+100, this._lion.sprite.body.y + 180)
        this._lion.sprite.setSize(this._lion.sprite.body.width-50, this._lion.sprite.body.height-70, false)
        this.restart()
        //region Animations
        this.anims.create({
            key: "h-lion-left",
            frames: this.anims.generateFrameNumbers("lion", { start: 0, end: 3 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "h-lion-turn",
            frames: [{key: "lion", frame: 4}],
            frameRate: 20,
        })
        this.anims.create({
            key: "h-lion-right",
            frames: this.anims.generateFrameNumbers("lion", { start: 5, end: 8 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "v-lion-left",
            frames: this.anims.generateFrameNumbers("lion", { start: 18, end: 21 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "v-lion-turn",
            frames: [{key: "lion", frame: 22}],
            frameRate: 20,
        })
        this.anims.create({
            key: "v-lion-right",
            frames: this.anims.generateFrameNumbers("lion", { start: 23, end: 26 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "h-bobLion-left",
            frames: this.anims.generateFrameNumbers("lion", { start: 9, end: 12 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "h-bobLion-right",
            frames: this.anims.generateFrameNumbers("lion", { start: 14, end: 17 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "v-bobLion",
            frames: this.anims.generateFrameNumbers("lion", { start: 27, end: 27 }),
            frameRate: 10,
            repeat:-1
        })
        //endregion
        this._totalStars = LionDance.info.maxTries * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._totalStars}`)
        this.physics.add.collider(this._lion.sprite, this.bob, () => {
            if (this._lion.mounted >= LionDance.info.maxTries) return
            const atRest = (a) => (a.x === 0 && a.y === 0);
            const headOn = (a, b) => {
                const collision = {
                    horizontal: (a, b) => a.x !== 0 && Math.sign(a.x) === -Math.sign(b.x),
                    vertical: (a, b) => a.y !== 0 && Math.sign(a.y) === -Math.sign(b.y)
                }
                return collision.horizontal(a, b) || collision.vertical(a, b)
            }
            if ( atRest(this._bobDirection.velocity) || headOn(this._lion.current.direction, this._bobDirection.velocity)) {
                this.peiPeiSay("Oops! You have to join the lion from the back!")
                this.sound.play("wrong")
                this.bob.anims.stop()
                this.lionAnim.stop()
                this.physics.pause()
                this._bobInLionsBack = true
                this.time.addEvent({ delay: 2000, callback: ()=> {
                    this._bobInLionsBack = false
                    this.physics.resume()
                    this.restart()
                }, callbackScope: this })
                return
            }
            this._lion.mounted++
            this.physics.pause()
            let score = this.board.score.text
            this.board.score.setText(`${parseInt(score) + 5} / ${this._totalStars}`)
            this.bob.setVisible(false)
            this._bobLion = true
            if (this._lion.mounted === LionDance.info.maxTries) { 
                this.peiPeiSay("Mission Accomplished!")
                this.win(this.board.score.text, this._level.current.index + 1)
                return
            }
            Utility.make.dialog.message(this, {
                title: "Round Won",
                message: `Good Job! Get ready for round ${this._lion.mounted + 1}!`,
                scale: 1 / Level.CAMERA_ZOOM,
                proceed: () => {
                    this.bob.setVisible(true)
                    this._bobLion = false
                    this.physics.resume()
                    this.restart()
                }
            })
        })
    }
    update(time, delta){
        super.update(time, delta)
        const l = this._lion
        l.sprite.setVelocity(0)
        if(this._bobInLionsBack) return
        this.move()
        const lionDir = {x: l.current.direction.x, y: l.current.direction.y}
        this.lionAnim = this._lion.sprite.anims
        if (this._bobLion) {
            lionDir.x === 1 ? this.lionAnim.play("h-bobLion-right", true) :
            lionDir.x === -1 ? this.lionAnim.play("h-bobLion-left", true) :
            lionDir.y === 1 ? this.lionAnim.play("h-lion-right", true) :
            this.lionAnim.play("v-bobLion", true)
            return;
        }
        lionDir.x === 1 ? this.lionAnim.play("v-lion-right", true) :
        lionDir.x === -1 ? this.lionAnim.play("v-lion-left", true) :
        lionDir.y === 1 ? this.lionAnim.play("v-lion-right", true) :
        this.lionAnim.play("v-lion-left", true) 
    }
    turn() {
        const l = this._lion
        const directions = {
            E: { x: 1, y: 0 },
            W: { x: -1, y: 0 },
            S: { x: 0, y: 1 },
            N: { x: 0, y: -1 }
        }
        const next = () => {
            l.current.path = Math.floor(Math.random() * l.paths.length)
            l.current.step = -1
        }
        if (l.current.path === null || l.current.step === l.paths[l.current.path].length - 1) next()
        l.current.step++
        const s = l.paths[l.current.path][l.current.step]
        l.current.direction = directions[s.substring(0, 1)]
        l.current.max = s.substring(1)
        l.last = { x: l.sprite.x, y: l.sprite.y }
    }
    move() {
        const l = this._lion
        l.sprite.x += l.current.direction.x * l.speed()
        l.sprite.y += l.current.direction.y * l.speed()
        if (l.distance() > l.current.max) {
            l.sprite.x = l.last.x + l.current.direction.x * l.current.max
            l.sprite.y = l.last.y + l.current.direction.y * l.current.max
            this.turn()
        }
    }
    restart() {
        this._lion.sprite.setX(2170).setY(600).setVisible(true)
        this._lion.current = {
            path: null,
            step: null,
            direction: {x: 0, y: 0},
            max: 0
        }
        this._bob.x = this._options.x * this._scale.x
        this._bob.y = this._options.y * this._scale.y
        this.turn()
     }

     play(direction) {
        let d = {...direction, animation: `${direction.animation}`};
        if(this._bobInLionsBack) return
        super.play(d)
    }
}